<div class="action">
  <div class="header">
    <span class="type" [ghs-label]="'editor.action.type'"></span>

    <label class="small">
      @if (!hideValues) {
      <input type="checkbox" [(ngModel)]="action.small" (change)="change()">
      }
      @if (!hideValues) {
      <span [ghs-label]="'editor.action.small'"></span>
      }
    </label>

    <span class="spacer"></span>

    @if (subactionIndex || subactionIndex == 0) {
    <a class="remove" (click)="subActionRemoved.emit(subactionIndex)">
      <img class="ghs-icon" src="./assets/images/minus.svg">
      <span [ghs-label]="'editor.action.removeSubAction'"></span>
    </a>
    }
  </div>

  <select [ngModel]="action.type" placeholder="type" (ngModelChange)="changeType($event)">
    @for (actionType of actionTypes; track actionType) {
    <option [value]="actionType"><span [ghs-label]="'game.action.' + actionType"></span>
    </option>
    }
  </select>

  @if (!hideValues && ![ActionType.jump].includes(action.type)) {
  <label><span [ghs-label]="'editor.action.value'"></span></label>
  }

  @if (action.type == ActionType.specialTarget) {
  <select [ngModel]="value" (ngModelChange)="changeSpecialTarget($event, subValue)">
    @for (specialTarget of ActionSpecialTarget; track specialTarget) {
    <option [value]="specialTarget">
      <span [ghs-label]="'game.specialTarget.' + specialTarget" [ghs-label-args]="['X']" [style]="'gh'"></span>
    </option>
    }
  </select>
  @if (subValue) {
  <label class="inline">
    X: <input type="text" [ngModel]="subValue" (ngModelChange)="changeSpecialTarget(value, $event)">
  </label>
  }
  }

  @if (!hideValues && ![ActionType.area, ActionType.card, ActionType.condition, ActionType.element,
  ActionType.elementHalf, ActionType.jump, ActionType.monsterType, ActionType.specialTarget, ActionType.summon,
  ActionType.custom].includes(action.type)) {
  <input type="text" [ngModel]="action.value" (ngModelChange)="action.value=valueChange($event)" (change)="change()">
  }

  @if (!hideValues && action.type == ActionType.custom) {
  <textarea [ngModel]="action.value" (ngModelChange)="action.value=valueChange($event)" (change)="change()">
  </textarea>
  }

  @if (action.type == ActionType.area) {
  <div class="area-container">
    <div class="hexes">
      <ghs-action-hex [action]="hexAction" [value]="'' + hexAction.value" (clickCallback)="toggleHex($event)"
        (doubleclickCallback)="removeHex($event)" [character]="character" [cardId]="cardId">
      </ghs-action-hex>
    </div>
    <textarea [ngModel]="hexAction.value" (ngModelChange)="changeHex($event)"></textarea>
  </div>
  }

  @if (action.type == ActionType.summon) {
  <div class="summon">
    <div class="summon-type">
      <label>
        <input type="radio" name="summonType" (change)="changeSummonType($event)" value="monster" [checked]="!summon">
        <span [ghs-label]="'editor.action.summon.type.monster'"></span>
      </label>
      <label>
        <input type="radio" name="summonType" (change)="changeSummonType($event)" value="summon"
          [checked]="summon"><span [ghs-label]="'editor.action.summon.type.summon'"></span>
      </label>
    </div>
    @if (!summon) {
    <div class="summon-monster">
      <select [(ngModel)]="monster" (change)="changeSummonMonster()">
        @for (monster of monsters; track monster) {
        <option [value]="monster">
          <span [ghs-label]="'data.monster.' + monster"></span>
        </option>
        }
      </select>
      <select [(ngModel)]="monsterType" (change)="changeSummonMonster()">
        <option></option>
        @for (monsterType of MonsterTypes; track monsterType) {
        <option [value]="monsterType">
          <span [ghs-label]="'monster.' + monsterType"></span>
        </option>
        }
      </select>
    </div>
    }
    @if (!!summon) {
    <div class="summon-form">
      <ghs-action-summon [action]="action" [additional]="true" [character]="character"
        [cardId]="cardId"></ghs-action-summon>
      <input class="summon-name" [(ngModel)]="summon.name" (change)="changeSummon()">
      <div class="grid">
        <span class="item">
          <input class="summon-health" [(ngModel)]="summon.health" (change)="changeSummon()">
        </span>
        <span class="item">
          <input class="summon-movement" [(ngModel)]="summon.movement" (change)="changeSummon()">
        </span>
        <a (click)="editSummonAction()">@if (!summon.action) {
          <span><span [ghs-label]="'editor.action.add'"></span></span>
          }</a>
        <span class="item">
          <input class="summon-attack" [(ngModel)]="summon.attack" (change)="changeSummon()">
        </span>
        <span class="item">
          <input class="summon-range" [(ngModel)]="summon.range" (change)="changeSummon()">
        </span>
        <a (click)="editSummonAdditionalAction()">
          @if (!summon.additionalAction) {
          <span [ghs-label]="'editor.action.add'"></span>
          }
        </a>
      </div>
    </div>
    }
  </div>
  }

  @if (action.type == ActionType.condition) {
  <select [(ngModel)]="value" (change)="changeCondition()">
    @for (condition of conditionNames; track condition) {
    <option [value]="condition">
      <span [ghs-label]="'game.condition.' + condition" [ghs-label-args]="['X']"></span>
    </option>
    }
  </select>
  @if (subValue) {
  <label class="inline">
    X: <input min="1" type="number" [(ngModel)]="subValue" (change)="changeCondition()">
  </label>
  }
  }

  @if (action.type == ActionType.card) {
  <select [(ngModel)]="value" (change)="changeCard()">
    @for (card of ActionCardTypes; track card) {
    <option [value]="card">
      <span [ghs-label]="'game.card.' + card" [ghs-label-args]="hasCardValue(card) ? [ 'X' ] : []"></span>
    </option>
    }
  </select>
  @if (subValue) {
  <label class="inline">
    X: <input min="1" type="number" [(ngModel)]="subValue" (change)="changeCard()">
  </label>
  }
  }

  @if (action.type == ActionType.element) {
  <select [(ngModel)]="action.value" (change)="change()">
    @for (element of Elements; track element) {
    <option [value]="element">
      <span [ghs-label]="'game.element.' + element"></span>
    </option>
    }
  </select>
  }

  <div class="action-element-half-container">
    @if (action.type == ActionType.elementHalf) {
    <select [(ngModel)]="value" (change)="changeElementHalf()">
      @for (element of HalfElementsLeft; track element) {
      <option [value]="element">
        <span [ghs-label]="'game.element.' + element"></span>
      </option>
      }
    </select>
    }

    @if (action.type == ActionType.elementHalf) {
    <select [(ngModel)]="subValue" (change)="changeElementHalf()">
      @for (element of HalfElementsRight; track element) {
      <option [value]="element">
        <span [ghs-label]="'game.element.' + element"></span>
      </option>
      }
    </select>
    }
  </div>

  @if (action.type == ActionType.monsterType) {
  <select [(ngModel)]="action.value" (change)="change()">
    @for (monsterType of MonsterTypes; track monsterType) {
    <option [value]="monsterType"><span [ghs-label]="'game.monster.' + monsterType"></span>
    </option>
    }
  </select>
  }

  @if (!hideValues && ![ActionType.area, ActionType.card, ActionType.condition, ActionType.concatenation,
  ActionType.custom, ActionType.grant, ActionType.grid, ActionType.jump, ActionType.monsterType,
  ActionType.specialTarget, ActionType.summon, ActionType.trigger].includes(action.type)) {
  <label><span [ghs-label]="'editor.action.valueType'"></span></label>
  <select [(ngModel)]="action.valueType" placeholder="valueType" (change)="change()">
    @for (valueType of ActionValueTypes; track valueType) {
    <option [value]="valueType"
      [selected]="action.valueType == valueType || !action.valueType && valueType == ActionValueType.fixed">
      <span [ghs-label]="'editor.action.valueType.' + valueType"></span>
    </option>
    }
  </select>
  }

  @if (!hideValues) {
  <div class="enhancements">
    <div class="header">
      <label [ghs-label]="'editor.action.enhancements'"></label>
      <a class="add" (click)="addEnhancement()">
        <img class="ghs-icon" src="./assets/images/plus.svg">
        <span [ghs-label]="'editor.action.addEnhancement'"></span>
      </a>
    </div>
    @if (action.enhancementTypes) {
    @for (i of [] | ghsRange:action.enhancementTypes.length; track i) {
    <div class="enhancement">
      <select [(ngModel)]="action.enhancementTypes[i]" (change)="change()">
        @for (e of EnhancementTypes; track e) {
        <option [value]="e">
          <span [ghs-label]="'character.abilities.enhancements.types.' + e"></span>
        </option>
        }
      </select>
      <a (click)="removeEnhancement(i)">
        <img class="ghs-icon" src="./assets/images/minus.svg">
        <span [ghs-label]="'editor.action.removeEnhancement'"></span>
      </a>
    </div>
    }
    }
  </div>
  }

  <div class="subactions" cdkDropList (cdkDropListDropped)="dropSubAction($event)">
    <div class="header">
      <label [ghs-label]="'editor.action.subActions'"></label>
      <a class="add" (click)="addSubAction()">
        <img class="ghs-icon" src="./assets/images/plus.svg">
        <span [ghs-label]="'editor.action.addSubAction'"></span>
      </a>
    </div>

    @for (subAction of action.subActions | trackUUID; track subAction._trackUUID; let i = $index) {
    <div class="subaction" cdkDrag>
      <span class="handle" cdkDragHandle><img class="ghs-icon" src="./assets/images/menu.svg"></span>
      <ghs-editor-action [action]="action.subActions[i]" [subactionIndex]="i"
        (subActionRemoved)="removeSubAction($event)" (actionChange)="changeSubAction(i, $event)"></ghs-editor-action>
    </div>
    }
  </div>
</div>